module.exports = __webpack_public_path__ + "img/img6.fc05930a.png";